import { Component, Input, OnInit } from '@angular/core';
import { Localize } from 'qp-ui-interface';
import { ConfigService } from '../../services/config.service';
import { getDeviceType } from '../../utils/deviceUtils';

@Component({
  selector: 'app-cast',
  templateUrl: './cast.component.html',
  styleUrls: ['./cast.component.scss'],
})
export class CastComponent implements OnInit {
  @Input() width: string = '10.42vw';
  @Input() height: string = '10.42vw';
  @Input() roleName: string;
  @Input() updatedTime: string;
  @Input() localizedName: Localize[];
  @Input() id: string;
  @Input() lang = 'en';
  constructor(private readonly configService: ConfigService) {}

  imageSrc: string = '';

  ngOnInit(): void {
    this.imageSrc =
      this.getCastImage() || '/assets/icons/placeholder_no_image.svg';
  }

  get name() {
    return this.localizedName.find((item) => item.languageCode === this.lang)
      ?.localizeName;
  }

  onCastImageError(event: Event): void {
    const target = event.target as HTMLImageElement;

    if (!target.src.includes('placeholder_no_image.svg')) {
      target.src = '/assets/icons/placeholder_no_image.svg';
    }
  }

  getCastImage(): string {
    const width = 310;
    /* return `${this.configService.applicationConfig.imageResizeURL}/image/${id}/0-1x1.jpg?width=${width}&dt=${getDeviceType()}
    &appVersion=${
      this.newrelicStore.getApplicationInfo().appVersion
    }
    &updatedTime=${this.updatedTime}`; */
    return `${this.configService.applicationConfig.imageResizeURL}/image/${
      this.id
    }/0-1x1.jpg?width=${width}&dt=${getDeviceType()}&updatedTime=${
      this.updatedTime
    }`;
  }
}
